<template>
	<div class="egg-choose-item">
		<!-- 列 -->
		<div style="font-size:12px; overflow: auto; color: #333;height: calc(100vh - 80px);"
		:style="!isSearch?'height: calc(100vh - 40px)':'height: calc(100vh - '+(topH || 80)+'px)'"
		> 
			<table cellspacing="0" :class="tableclass">
				<tr class="regular">
					<th v-for="item in column" :key="item.id" 
					:rowspan="item.listType=='list'?1:2"
					:colspan="item.listType=='list'?item.labelList.length:1"
					> 
					<div>{{ item.label }}</div>
				</th>
				</tr>
				<tr>
					<template v-for="item1 in column" v-if="item1.listType=='list'" >
						<th style="background: #f5f7fa;font-weight: bold;top:28px" v-for="labelList in item1.labelList" :key="labelList.id" >{{ labelList.label }}</th>
					</template>
					
				</tr>
				<tr v-for="(item,index) in list" :key="index" v-if="list&&list.length>0"
					:class="item['rowclass'] || ''"
					>
					<template v-for="(itemc,indexc) in column"   >
						<td  v-if="itemc.listType!='list'"
							:class="item['rowclass1']&&!item.noColor?'rowclass'+item['rowclass1'] :''"
							:style="!item.noRowColor?(item['rowclass']&&item['rowclass']==1?'background:#f0f9eb;':
							item['rowclass']&&item['rowclass']==2?'background:#fdf5e6;':
							columnStyleArr.indexOf(indexc)>-1?'background:'+columnStyleArrColor[columnStyleArr.indexOf(indexc)]+';':''):''"
							>
							{{ itemc.listOptions?itemc.listOptions[item[itemc.id+'']]: item[itemc.id+''] }}
							<span v-if="itemc.id1&&item[itemc.id1+'']"><br/>{{ item[itemc.id1+''] }}</span>
							<span v-if="itemc.id2&&item[itemc.id2+'']"><br/>{{ item[itemc.id2+''] }}</span>
						</td>
						<td
						
						:class="item['rowclass1']&&!item.noColor?'rowclass'+item['rowclass1'] :''"

						:style="!item.noRowColor?(item['rowclass']&&item['rowclass']==1?'background:#f0f9eb;':
							item['rowclass']&&item['rowclass']==2?'background:#fdf5e6;':
						columnStyleArr.indexOf(indexc+'-'+il)>-1?'background:'+columnStyleArrColor[0]+';':'')+
						
						(itemc.colorStr&&((labelList.label.indexOf('率')>-1)||(itemc.label.indexOf('率')>-1))?'color:red;':
              itemc.colorStr&&(labelList.label.indexOf('计')>-1)?'color:blue;':''):''
						" 
							v-for="(labelList,il) in itemc.labelList" v-else :key="labelList.id" 
							
							>{{ item[labelList.id+'']  }}</td>
					</template>
					
				</tr>
			</table>
			<div v-if="!list||list.length==0" class="no-list">
				<svg t="1699860205428" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7038" width="50" height="50"><path d="M958.660364 288.642956l0.024559 0L511.996418 65.304332 66.119395 288.23568l-0.830925 0L65.28847 735.350904l446.707948 223.344764 446.714088-223.344764L958.710506 288.642956 958.660364 288.642956 958.660364 288.642956 958.660364 288.642956zM511.996418 119.41267l335.906399 168.380942-127.914298 64.48671L382.46939 184.402847 511.996418 119.41267 511.996418 119.41267 511.996418 119.41267zM323.935252 216.08543l341.852832 164.712389-153.816225 74.501808L176.095135 288.642956 323.935252 216.08543 323.935252 216.08543 323.935252 216.08543zM121.126196 345.139691l17.753339 0-17.753339-0.652869 0-27.915793L484.086765 498.05643l0 390.871245L121.126196 707.446367 121.126196 345.139691 121.126196 345.139691 121.126196 345.139691zM902.86664 372.414895l0 335.031473L539.905048 888.927675 539.905048 498.05643 902.86664 316.571029 902.86664 372.414895 902.86664 372.414895 902.86664 372.414895z" fill="#CCCCCC" p-id="7039"></path></svg>
				<div>暂无数据</div>
			</div> 
		</div>
		</div>
</template>
<script>  
 
	export default {

		data() {
			return {
			};
		},
		props: { 
			list:{
				type: Array,
      			default:() => []
			}, 
			column:{
				type: Array,
      			default:() => []
			},
			columnStyleArr:{
				type: Array,
      			default:() => []
			},
			columnStyleArrColor:{
				type: Array,
      			default:() => []
			},
			tableclass:{
				type:String,
				default:''
			},
			isSearch:{
				type:Boolean,
				default:true
			},
			topH:{
				type:String,
				default:''
			},
		},
		onLoad() {  
		},
		
		methods: {
		}
	};
</script>
<style > 
.egg-choose-item{
	padding-top: 35px; 
}
.egg-choose-item .item{
	padding: 10px;
    border-bottom: 1px solid #eee;
} 
table{
	table-layout:fixed;
	word-break:break-all;
	text-align: center;
	font-size: 14px;
}
th {
  position: sticky;
  top: 0; /* 头部固定在顶部 */
  background-color: white; /* 设置背景色以匹配容器的背景色 */
  z-index: 10; /* 确保头部在内容之上 */
  overflow: hidden; /* 防止内容溢出 */
  text-overflow: ellipsis; /* 显示省略号 */
  white-space: nowrap; /* 不换行 */
  padding: 6px;
  background: #f5f7fa;
  border-collapse: collapse; 
  border-right: 1px solid #dfe6ec;
  flex-shrink: 0;
  word-wrap:break-word;
}
tr {
  position: relative; /* 相对定位，可以让表格内容在滚动时保持正确的层叠顺序 */
}
td{
  overflow: hidden; /* 防止内容溢出 */
  text-overflow: ellipsis; /* 显示省略号 */
  white-space: nowrap; /* 不换行 */
  border-bottom: 1px solid #dfe6ec;
  border-left: 1px solid #dfe6ec;
  border-collapse: collapse;
  padding: 6px;
}
th div{
	margin: 0;
	padding: 0;
}
 
</style>